import React, { useState, useEffect } from "react";
import "./App.css";
import UserRoute from "./Routes/UserRoute";
import AuthRoute from "./Routes/AuthRoute";
import AuthContext from "./utilities/AuthContext";
import authStorage from "./utilities/Storage";
import AdminRoute from "./Routes/AdminRoute";

function App() {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  function restoreUser() {
    setIsLoading(true);
    const storedUser = authStorage.getUser();

    if (!storedUser) {
      setIsLoading(false);
      return;
    }

    try {
      const parsedUser = JSON.parse(storedUser);
      // Debug: Log the user data to see what we're working with
      console.log("Restored user data:", parsedUser);
      setUserData(parsedUser);
    } catch (error) {
      console.error("Failed to parse user data:", error);
      authStorage.removeUser();
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    restoreUser();
  }, []);

  const updateUserData = (newUserData) => {
    // Debug: Log when user data is updated
    console.log("Updating user data:", newUserData);
    setUserData(newUserData);
  };

  // Debug: Log the current user data and role
  console.log("Current user data:", userData);
  console.log("User role:", userData?.rank_);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <AuthContext.Provider
      value={{
        user: userData,
        setUser: updateUserData,
        logout: () => {
          authStorage.removeUser();
          setUserData(null);
        },
      }}
    >
      {userData ? (
        userData.status === "PENDING" ? (
          <AuthRoute />
        ) : userData.rank_ === "admin" || userData.role === "admin" ? (
          <AdminRoute />
        ) : (
          <UserRoute />
        )
      ) : (
        <AuthRoute />
      )}
    </AuthContext.Provider>
  );
}

export default App;
